import { Shield, Mail } from "lucide-react";
import { privacyPolicy } from "@/lib/content";
import { useLanguage } from "@/lib/language";

function Reveal({
  children,
  className,
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) {
  return <div className={className}>{children}</div>;
}

export function PrivacyContent() {
  const { t } = useLanguage();
  const h = privacyPolicy.header;
  const s = privacyPolicy.sections;
  const c = privacyPolicy.contact;

  return (
    <>
      {/* HEADER */}
      <section className="relative overflow-hidden bg-topbar text-topbar-foreground">
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-40 bg-gradient-to-b from-transparent to-background" />
        <div className="relative mx-auto max-w-none w-full px-4 lg:px-8 py-28 sm:py-32 lg:py-40">
          <div className="max-w-3xl text-start">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-primary">
              <Shield className="size-3.5" />
              {t(h.lastUpdated)}
            </span>
            <h1 className="mt-6 text-4xl font-extrabold leading-tight text-background sm:text-5xl lg:text-6xl">
              {t(h.title)}
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-topbar-foreground/80 sm:text-lg">
              {t(h.intro)}
            </p>
          </div>
        </div>
      </section>

      {/* SECTIONS */}
      <section className="mx-auto max-w-4xl px-4 py-20 sm:py-28">
        <div className="space-y-16">
          {s.map((section, i) => (
            <Reveal key={section.id} delay={i * 0.08}>
              <div className="rounded-2xl border border-white/10 bg-black p-8 shadow-soft sm:p-10">
                <h2 className="text-xl font-bold text-white sm:text-2xl">{t(section.title)}</h2>
                <div className="mt-4 h-1 w-16 rounded-full bg-primary" />
                <p className="mt-6 text-sm leading-relaxed text-white/80 sm:text-base">
                  {t(section.content)}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* CONTACT */}
        <Reveal className="mt-16">
          <div className="rounded-2xl bg-black p-8 text-center sm:p-10">
            <h3 className="text-lg font-bold text-white sm:text-xl">{t(c.title)}</h3>
            <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/80 sm:text-base">
              {t(c.content)}
            </p>
            <a
              href={`mailto:info@iraqcert.com`}
              className="group mx-auto mt-6 inline-flex items-center gap-2 rounded-full bg-primary px-7 py-3.5 text-sm font-semibold text-primary-foreground shadow-soft transition-all hover:brightness-110"
            >
              <Mail className="size-4" />
              info@iraqcert.com
            </a>
          </div>
        </Reveal>
      </section>
    </>
  );
}
